import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { setupGlobalErrorHandlers } from './lib/errorReporting'
import { initStorageBackend } from './lib/storageBackend'
import { getStorageString, STORAGE_KEYS } from './lib/storageService'

// Install global error / unhandled-rejection handlers before anything else.
setupGlobalErrorHandlers()

async function boot() {
  // Initialize platform-aware storage (loads Preferences on native, no-op on web)
  await initStorageBackend()

  // Initialize dark mode before render to prevent flash
  const savedDarkMode = getStorageString(STORAGE_KEYS.DARK_MODE);
  const prefersDark = savedDarkMode !== null
    ? savedDarkMode === 'true'
    : window.matchMedia('(prefers-color-scheme: dark)').matches;
  if (prefersDark) {
    document.documentElement.classList.add('dark');
  }

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}

boot()
